<div class="card">
  <header class="card-header">
    <p class="card-header-title is-size-4 has-background-white-ter">{{ 'submittedClaim.title' | localize }}</p>
  </header>

  <div class="card-content">
    <article class="content">
      <div class="message is-success">
        <div class="message-body">
          <span class="is-size-5">{{ 'submittedClaim.thankYou' | localize }}</span>
          <span class="is-size-6 pl-3">{{ 'submittedClaim.successMessage' | localize }}</span>
        </div>
      </div>
    </article>

    <div class="columns is-multiline">
      <div class="column is-full">
        <p><span class="has-text-weight-medium is-underlined">{{ 'submittedClaim.claimId' | localize }}:</span> {{ claimMetadata?.claimID }}</p>
      </div>

      <div class="column is-half">
        <p><span
          class="has-text-weight-medium is-underlined">{{ 'submittedClaim.insuranceClaimRef' | localize }}:</span> {{ claimMetadata?.insuranceClaimReference }}
        </p>
      </div>

      <div class="column is-half">
        <p><span
          class="has-text-weight-medium is-underlined">{{ 'submittedClaim.lossAdjusterRef' | localize }}:</span> {{ claimMetadata?.lossAdjusterClaimReference }}
        </p>
      </div>

      <div class="column is-half">
        <p><span class="has-text-weight-medium is-underlined">{{ 'submittedClaim.unitOwnerName' | localize }}:</span> {{ claimMetadata?.unitOwnerName }}
        </p>
      </div>

      <div class="column is-half">
        <p><span class="has-text-weight-medium is-underlined">{{ 'submittedClaim.unitNumber' | localize }}:</span> {{ claimMetadata?.unitNumber }}</p>
      </div>

      <div class="column is-half">
        <p><span
          class="has-text-weight-medium is-underlined">{{ 'submittedClaim.condominiumName' | localize }}:</span> {{ claimMetadata?.condominiumName }}</p>
      </div>

      <div class="column is-half">
        <p><span class="has-text-weight-medium is-underlined">{{ 'submittedClaim.address' | localize }}:</span> {{ claimMetadata?.address }}</p>
      </div>
    </div>
  </div>
  <footer class="card-footer">
    <div class="card-footer-item">
      <a class="button is-dark" routerLink="/">{{ 'submittedClaim.backToLanding' | localize }}</a>
      <span class="pl-3 pr-3"> </span>
      <button class="button is-dark" (click)="createNewClaim()">{{ 'submittedClaim.startNewClaim' | localize }}</button>

    </div>
  </footer>
</div>
